<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
		</div>
		<div class="orderListBox">
			<div class="orderList" v-if="integralData.length">
				<div class="orderItem" v-for="(item,index) in integralData" :key="index"
					@click="curGoods = item;workDetailsShow = true">
					<img class="orderImg" :src="item.img" />
					<div class="orderName">{{item.title}}</div>
					<div class="collection" @click.stop="collectionGoods(item)">
						<img class="collectionIcon" src="../assets/Register/collection.png" />
						收藏
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination style="padding: .32rem 0 0;" :pageSize="8" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<WorkDetailsDialog :show="workDetailsShow" :isBuy="curGoods.is_buy" :goodsId="curGoods.id"
			@close="workDetailsShow = false" @updateData="wishList" />
	</div>
</template>

<script>
	import WorkDetailsDialog from '../components/WorkDetailsDialog.vue'
	export default {
		name: 'MyCollection',
		components: {
			WorkDetailsDialog
		},
		data() {
			return {
				// 分类导航
				categories: [{
						key: 1,
						name: '材质作品'
					},
					{
						key: 2,
						name: '模型作品'
					}
				],
				total: 0,
				is_buy: 0,
				curGoods: {},
				curOrder: {},
				currentPage: 1,
				integralData: [],
				activeCategory: 1,
				workDetailsShow: false,
				dialogReportVisible: false,
				dialogApplyInvoiceViable: false,
			}
		},
		mounted() {
			this.wishList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.wishList()
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.currentPage = 1
				this.wishList()
			},
			collectionGoods(item) {
				this.$api.post('/Hua/sc_work', {
					id: item.id
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.wishList()
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToDetails(item) {
				this.$router.push({
					path: '/order-details',
					query: {
						type: 4,
						orderId: item.id
					}
				})
			},
			confirmOrder(item) {
				this.$confirm('当前订单确认收货吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/integral_order_sh', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			delOrder(item) {
				this.$confirm('确认删除当前订单吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/OrderIntegral/order_integral_del', {
						order_id: item.id,
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.integralOrderList()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(() => {

				});
			},
			wishList() {
				this.$api.post('Hua/user_hua_list', {
					pagesize: 8,
					p: this.currentPage,
					type: this.activeCategory,
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.integralData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: 0 .4rem .24rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .32);
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: rgba(255, 255, 255, .6);
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: rgba(255, 255, 255, 1);
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: rgba(22, 115, 230, 1);
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}

	.orderListBox {
		display: flex;
		flex-direction: column;

		.orderList {
			display: flex;
			flex-wrap: wrap;

			.orderItem:nth-child(4n) {
				margin-right: 0;
			}

			.orderItem {
				margin-top: .32rem;
				margin-right: .18rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				cursor: pointer;

				.orderImg {
					width: 2.05rem;
					height: 2.05rem;
					border-radius: .08rem;
					object-fit: cover;
				}

				.orderName {
					margin-top: .18rem;
					width: 2.05rem;
					font-weight: 500;
					font-size: .16rem;
					color: #FFFFFF;
					line-height: .22rem;
				}

				.collection {
					margin-top: .24rem;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 1.88rem;
					height: .36rem;
					background: #1673E6;
					border-radius: .18rem;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					line-height: .2rem;

					.collectionIcon {
						margin-right: .04rem;
						width: .14rem;
						height: .14rem;
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;


				.wuLiuContent {
					margin-bottom: .16rem;
					font-weight: 400;
					font-size: .14rem;
					line-height: .2rem;
					color: #252525;
				}

				.el-form {

					&-item:nth-child(4),
					&-item:nth-child(5) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							width: 1.1rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .16rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>